import { useCallback, useEffect, useState } from 'react';

type CopyState = 'idle' | 'copied' | 'failed';

/** Clipboard access needs a secure context, so failure is a normal outcome here. */
export function CopyButton({ value, label = 'Copy' }: { value: string; label?: string }) {
  const [state, setState] = useState<CopyState>('idle');

  useEffect(() => {
    if (state === 'idle') return;
    const timer = window.setTimeout(() => setState('idle'), 1600);
    return () => window.clearTimeout(timer);
  }, [state]);

  const copy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(value);
      setState('copied');
    } catch {
      setState('failed');
    }
  }, [value]);

  return (
    <button
      type="button"
      className={`copy-btn copy-btn--${state}`}
      onClick={() => void copy()}
      aria-label={`Copy ${value}`}
      title={`Copy ${value}`}
    >
      {state === 'copied' ? 'Copied' : state === 'failed' ? 'Failed' : label}
    </button>
  );
}
